import React from "react";
import {Button, Card, DatePicker, Form, Input, Select, Space, Table} from "antd";
import {
    AuthenticatedGetToApi,
    AuthenticatedPostToApi,
    FILEDOWNLOADAuthenticatedPostToApi,
    UnauthenticatedPostToApi
} from "../../helpers/api";
import {DownloadOutlined} from "@ant-design/icons";
const { Option } = Select;

function ExecutiveStatsDepartment() {
    const [DepartmentList, SetDepartmentList] = React.useState([])
    const [dataSource, SetDataSource] = React.useState({})
    const [savedReq, SetSavedReq] = React.useState({})
    const [isLoading, setIsLoading] = React.useState(false)
    const onFinish = (values) => {
        setIsLoading(true)
        SetSavedReq(values)
        SetDataSource({})
        AuthenticatedPostToApi('/api/Report/DepartmentExecutiveStatsReport',values).then(r=>{
            SetDataSource(r)
            setIsLoading(false)
        }).catch(()=>setIsLoading(false))
    };

    const runExport = async (pdf) => {
        setIsLoading(true)
        FILEDOWNLOADAuthenticatedPostToApi('/api/ReportExport/DepartmentExecutiveStatsReport?pdf='+pdf,savedReq).then(r=>{
            console.log(r)
            const blob = new Blob([r]);
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = `ReportExport-${+new Date()}.`+ (pdf?'pdf':'xlsx');
            link.click();
            link.remove();
            setIsLoading(false)
        }).catch(()=>setIsLoading(false))
    }
    
    const columns = [
        {
            title: 'Dept',
            dataIndex: 'Dept',
            key: 'Dept',
        },
        {
            title: 'State DMV Hit',
            dataIndex: 'State DMV Hit',
            key: 'State DMV Hit',
        },
        {
            title: 'NCIC Hit',
            dataIndex: 'NCIC Hit',
            key: 'NCIC Hit',
        },
        {
            title: 'AOC Hit',
            dataIndex: 'AOC Hit',
            key: 'AOC Hit',
        },
        {
            title: 'State Want Hit',
            dataIndex: 'State Want Hit',
            key: 'State Want Hit',
        },
        {
            title: 'NLETS Want',
            dataIndex: 'NLETS Want',
            key: 'NLETS Want',
        },
        {
            title: 'NLETS Veh Hit',
            dataIndex: 'NLETS Veh Hit',
            key: 'NLETS Veh Hit',
        },
        {
            title: 'Boat Hit',
            dataIndex: 'Boat Hit',
            key: 'Boat Hit',
        },
        {
            title: 'Gun Hit',
            dataIndex: 'Gun Hit',
            key: 'Gun Hit',
        },
        {
            title: 'Article Hit',
            dataIndex: 'Article Hit',
            key: 'Article Hit',
        },
        {
            title: 'Flag 3',
            dataIndex: 'Flag 3',
            key: 'Flag 3',
        },
        {
            title: 'NCIC Stl Veh',
            dataIndex: 'NCIC Stl Veh',
            key: 'NCIC Stl Veh',
        },
        {
            title: 'Total Unique Hits',
            dataIndex: 'Total Hits',
            key: 'Total Hits',
        },
        {
            title: 'Total Checks',
            dataIndex: 'Total Checks',
            key: 'Total Checks',
        },
        {
            title: 'Grand Total',
            dataIndex: 'Grand Total',
            key: 'Grand Total',
        },
        
    ];

    const LoadDepts = async () => {
        let r = await AuthenticatedGetToApi('/api/Central/MyDepartmentList')
        SetDepartmentList(r)
    }

    React.useEffect(()=>{
        LoadDepts();
    },[])

    

    return (
        <div>
            <Card size="small" title={"Executive Stats Report"}  style={{ width: "100%", marginTop:10 }}>

                <Form
                    initialValues={{ remember: true }}
                    onFinish={onFinish}
                    layout={"horizontal"}
                >
                    <Space direction="horizontal">
                        <Form.Item
                            name="reportTitle"
                            rules={[{ required: true, message: 'Report Title is Required' }]}
                        >
                            <Input addonBefore="Report Title"  placeholder="Report Title" allowClear={true} />
                        </Form.Item>


                        <Form.Item
                            name="sDept"
                            rules={[{ required: true, message: 'Department is Required' }]}
                        >
                            <Select showSearch={true} placeholder={"Department"} style={{ width: 150 }} allowClear={true}>
                                {DepartmentList.map((v,idx)=>(
                                    <Option value={v.value?.toString()} key={'dept'+idx}>{v.key?.toString()}</Option>
                                ))}

                            </Select>
                        </Form.Item>

                        <Form.Item
                            name="sStartDate"
                            rules={[{ required: true, message: 'Start Date is Required' }]}
                        >
                            <DatePicker allowClear={true} placeholder={'Start Date'} format={'MM/DD/YYYY'} />
                        </Form.Item>

                        <Form.Item
                            name="sEndDate"
                            rules={[{ required: true, message: 'End Date is Required' }]}
                        >
                            <DatePicker allowClear={true} placeholder={'End Date'} format={'MM/DD/YYYY'} />
                        </Form.Item>

                    </Space>
                    <Form.Item>
                        <Button htmlType="submit" loading={isLoading}>
                            Generate Report
                        </Button>
                    </Form.Item>

                </Form>

            </Card>
            {(dataSource && dataSource.DepartmentExecutiveStatsReport) &&
                <Card size="small" style={{ width: "100%", marginTop:10 }}>
                    <Button type="primary" icon={<DownloadOutlined />} style={{ marginLeft:10 }} onClick={()=>runExport(true)} loading={isLoading}>
                        Download PDF
                    </Button>
                    <Button type="primary" icon={<DownloadOutlined />} style={{ marginLeft:10 }} onClick={()=>runExport(false)} loading={isLoading}>
                        Download Excel
                    </Button>
                    <Table size="small" dataSource={dataSource.DepartmentExecutiveStatsReport} columns={columns} pagination={false}/>
                    
                </Card>
            }

        </div>
    );
}

export default ExecutiveStatsDepartment;